'use strict';
angular.module('sysMgrSensitiveWordCtrlModule', [])
    .factory('sensitiveAlert', ['$modal', '$compile', '$timeout', function($modal, $compile, $timeout) {
        return {
            multiReportsAlert: function(data, callback) {
                var modalInstance = $modal.open({
                    templateUrl: './manageConfig/sysManageMent/sensitiveWord/template/multiReportsAlert.html',
                    windowClass: 'senMultiReportsAlert',
                    backdrop: false,
                    controller: 'senMultiReportsAlertCtrl',
                    resolve: {
                        data: function() {
                            return data;
                        }
                    }
                });
                modalInstance.result.then(function() {
                    if (angular.isFunction(callback)) {
                        callback();
                    }
                });
            }
        };
    }])
    .controller('senMultiReportsAlertCtrl', ['$scope', '$modalInstance', 'data', function($scope, $modalInstance, data) {
        initStatus();
        initData();

        function initStatus() {
            $scope.status = {
                'issuccess': data.ISSUCCESS,
                'title': data.TITLE
            };
            $scope.reports = {
                'success': [],
                'fail': []
            };
        }

        function initData() {
            if (data.ISSUCCESS == 'false') {
                var report = '';
                for (var i = 1; i < data.REPORTS.length; i++) {
                    report = data.REPORTS[i];
                    if (report.ISSUCCESS == 'true') {
                        $scope.reports.success.push(report);
                    } else {
                        $scope.reports.fail.push(report);
                    }
                }
            } else {
                $scope.reports.fail = angular.copy(data.REPORTS).splice(1);
            }
            $scope.reports.summary = data.REPORTS[0];
        }

        $scope.cancel = function() {
            $modalInstance.close();
        };
        $scope.confirm = function() {
            $modalInstance.close();
        };
    }])
    .controller('sensitiveBatchAddCtrl', ['$scope', '$filter', '$modalInstance', '$validation', '$timeout', 'initManageConSelectedService', 'modalDialog', function($scope, $filter, $modalInstance, $validation, $timeout, initManageConSelectedService, modalDialog) {
        initData();
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        $scope.status = {
            errorInput: false
        };
        $scope.leave = function() {
            if ($('tags-input').hasClass('ng-dirty')) {
                if ($scope.sensitiveArray.length === 0) {
                    $scope.status.errorInput = true;
                    $scope.isShowKeywordTips = true;
                    $scope.keywordsTips = '这是必填项';
                } else {
                    $scope.isShowKeywordTips = false;
                    $scope.status.errorInput = false;
                }
            }
        };
        $scope.confirm = function() {
            if (angular.isUndefined($scope.sensitiveArray) || $scope.sensitiveArray.length === 0) {
                $scope.isShowKeywordTips = true;
                $scope.status.errorInput = true;
                $scope.keywordsTips = '这是必填项';
                return;
            }
            $validation.validate($scope.websiteSensitiveBatchAddForm).success(function() {
                var sensitiveObj = {
                    'sensitiveArray': $scope.sensitiveArray,
                    'sensitiveLevel': $scope.sensitiveLevel
                };
                $modalInstance.close(sensitiveObj);
            });
        };

        function initData() {
            // 初始化敏感级别
            $scope.sensitiveLevelJsons = initManageConSelectedService.websiteSensitiveLevel();
            $scope.sensitiveLevel = angular.copy($scope.sensitiveLevelJsons[0]);
        }
    }])
    .controller('sensitiveAddCtrl', ['$scope', '$modalInstance', '$validation', '$timeout', 'initManageConSelectedService', 'trsspliceString', 'item', function($scope, $modalInstance, $validation, $timeout, initManageConSelectedService, trsspliceString, item) {
        initStatus();
        initData();
        // 初始化状态
        function initStatus() {
            $scope.status = {
                isGroup: false,
                isModify: !!item,
                title: !!item ? '修改敏感词' : '添加敏感词',
                spechar: ';'
            };
            $scope.data = {
                sensitiveGroup: [{
                    content: ''
                }, {
                    content: ''
                }],
                sensitiveWord: []
            };
        }
        $scope.$on('quickTabChoose', function(event, data) {
            $scope.status.isGroup = data;
        });
        // 初始化数据
        function initData() {
            // 初始化敏感级别
            initSensitiveLevel();
            // 初始化敏感词和替换词
            $scope.data.sensitiveWord = $scope.status.isModify ? item.SENSITIVEWORDS : '';
            $scope.data.substituteWord = $scope.status.isModify ? item.SUBSTITUTEWORDS : '';
            // 初始化修改敏感词组
            if ($scope.status.isModify && item.ISWORDSGROUP == '1') {
                // $scope.data.substituteWord = '';
                $scope.status.isGroup = true;
                $scope.data.sensitiveword = [];
                // var sensitiveGroup = item.SENSITIVEWORDS.split(';');
                // angular.forEach(sensitiveGroup, function(value, key) {
                //     $scope.data.sensitiveGroup.push({
                //         content: value
                //     })
                // });
                var sensitiveword = item.SENSITIVEWORDS.split(';');
                angular.forEach(sensitiveword, function(value, key) {
                    $scope.data.sensitiveword.push({
                        name: value
                    });
                });
            }
        }
        // 初始化敏感级别
        function initSensitiveLevel() {
            if ($scope.status.isModify) {
                $scope.data.sensitiveLevelJsons = initManageConSelectedService.websiteSensitiveLevel();
                $scope.data.sensitiveLevel = angular.copy($scope.data.sensitiveLevelJsons[item.SENSITIVELEVELDESC == '一般' ? 0 : 1]);
            } else {
                $scope.data.sensitiveLevelJsons = initManageConSelectedService.websiteSensitiveLevel();
                $scope.data.sensitiveLevel = angular.copy($scope.data.sensitiveLevelJsons[0]);
            }
        }
        // $scope.data.sensitiveGroup.splice(index, 1);
        // };
        // 取消
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        // 确定
        $scope.confirm = function() {
            $validation.validate($scope.websiteSensitiveAddForm).success(function() {
                if ($scope.status.isGroup) {
                    var sensitiveObj = {
                        // 'sensitiveWord': trsspliceString.spliceString($scope.data.sensitiveGroup, 'content', $scope.status.spechar),
                        'sensitiveWord': $scope.data.sensitiveword,
                        'substituteWord': '',
                        'sensitiveLevel': $scope.data.sensitiveLevel,
                        'ISWORDSGROUP': 1
                    };
                } else {
                    var sensitiveObj = {
                        'sensitiveWord': $scope.data.sensitiveWord,
                        'substituteWord': $scope.data.substituteWord,
                        'sensitiveLevel': $scope.data.sensitiveLevel,
                        'ISWORDSGROUP': 0
                    };
                }
                $modalInstance.close(sensitiveObj);
            });
        };
        // initData();
        // $scope.cancel = function() {
        //     $modalInstance.dismiss();
        // };
        // $scope.confirm = function() {
        //     $validation.validate($scope.websiteSensitiveBatchAddForm).success(function() {
        //         var sensitiveObj = {
        //             'sensitiveArray': $scope.sensitiveArray,
        //             'sensitiveLevel': $scope.sensitiveLevel
        //         };
        //         $modalInstance.close(sensitiveObj);
        //     });
        // };

        // function initData() {
        //     //初始化敏感级别
        //     $scope.sensitiveLevelJsons = initManageConSelectedService.websiteSensitiveLevel();
        //     $scope.sensitiveLevel = angular.copy($scope.sensitiveLevelJsons[0]);
        //     if(angular.isDefined(item)){

        //     }
        // }
    }])
    .controller('sensitiveAddGroupCtrl', ['$scope', '$modalInstance', '$validation', '$timeout', 'initManageConSelectedService', 'trsspliceString', 'item', function($scope, $modalInstance, $validation, $timeout, initManageConSelectedService, trsspliceString, item) {
        initStatus();
        initData();
        // 初始化状态
        function initStatus() {
            $scope.status = {
                isGroup: !!item,
                isModify: !!item,
                title: !!item ? '修改敏感词组' : '添加敏感词组',
                spechar: ';'
            };
            $scope.data = {
                sensitiveGroup: [{
                    content: ''
                }, {
                    content: ''
                }],
                sensitiveWord: []
            };
        }
        $scope.$on('quickTabChoose', function(event, data) {
            $scope.status.isGroup = data;
        });
        $scope.leave = function() {
            if ($('tags-input').hasClass('ng-dirty')) {
                if ($scope.sensitiveArray.length === 0) {
                    $scope.status.errorInput = true;
                    $scope.isShowKeywordTips = true;
                    $scope.keywordsTips = '这是必填项';
                } else {
                    $scope.isShowKeywordTips = false;
                    $scope.status.errorInput = false;
                }
            }
        };
        // 初始化数据
        function initData() {
            // 初始化敏感级别
            initSensitiveLevel();
            // 初始化敏感词和替换词
            $scope.data.sensitiveWord = $scope.status.isModify ? item.SENSITIVEWORDS : '';
            $scope.data.substituteWord = $scope.status.isModify ? item.SUBSTITUTEWORDS : '';
            // 初始化修改敏感词组
            if ($scope.status.isModify && item.ISWORDSGROUP == '1') {
                // $scope.data.substituteWord = '';
                $scope.status.isGroup = true;
                $scope.data.sensitiveword = [];
                // var sensitiveGroup = item.SENSITIVEWORDS.split(';');
                // angular.forEach(sensitiveGroup, function(value, key) {
                //     $scope.data.sensitiveGroup.push({
                //         content: value
                //     })
                // });
                var sensitiveword = item.SENSITIVEWORDS.split(';');
                $scope.sensitiveArray = [];
                angular.forEach(sensitiveword, function(value, key) {
                    $scope.sensitiveArray.push({
                        name: value
                    });
                });
            }
        }
        // 初始化敏感级别
        function initSensitiveLevel() {
            if ($scope.status.isModify) {
                $scope.data.sensitiveLevelJsons = initManageConSelectedService.websiteSensitiveLevel();
                $scope.data.sensitiveLevel = angular.copy($scope.data.sensitiveLevelJsons[item.SENSITIVELEVELDESC == '一般' ? 0 : 1]);
            } else {
                $scope.data.sensitiveLevelJsons = initManageConSelectedService.websiteSensitiveLevel();
                $scope.data.sensitiveLevel = angular.copy($scope.data.sensitiveLevelJsons[0]);
            }
        }
        // $scope.data.sensitiveGroup.splice(index, 1);
        // };
        // 取消
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        // 确定
        $scope.confirm = function() {
            if (angular.isUndefined($scope.sensitiveArray) || $scope.sensitiveArray.length === 0) {
                $scope.status.errorInput = true;
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '这是必填项';
                return;
            }

            $validation.validate($scope.websiteSensitiveAddForm).success(function() {
                if ($scope.status.isGroup) {
                    var sensitiveObj = {
                        // 'sensitiveWord': trsspliceString.spliceString($scope.data.sensitiveGroup, 'content', $scope.status.spechar),
                        'sensitiveWord': $scope.sensitiveArray,
                        'substituteWord': '',
                        'sensitiveLevel': $scope.data.sensitiveLevel,
                        'ISWORDSGROUP': 1
                    };
                } else {
                    var sensitiveObj = {
                        'sensitiveWord': $scope.data.sensitiveWord,
                        'substituteWord': $scope.data.substituteWord,
                        'sensitiveLevel': $scope.data.sensitiveLevel,
                        'ISWORDSGROUP': 0
                    };
                }
                $modalInstance.close(sensitiveObj);
            });
        };
        // initData();
        // $scope.cancel = function() {
        //     $modalInstance.dismiss();
        // };
        // $scope.confirm = function() {
        //     $validation.validate($scope.websiteSensitiveBatchAddForm).success(function() {
        //         var sensitiveObj = {
        //             'sensitiveArray': $scope.sensitiveArray,
        //             'sensitiveLevel': $scope.sensitiveLevel
        //         };
        //         $modalInstance.close(sensitiveObj);
        //     });
        // };

        // function initData() {
        //     //初始化敏感级别
        //     $scope.sensitiveLevelJsons = initManageConSelectedService.websiteSensitiveLevel();
        //     $scope.sensitiveLevel = angular.copy($scope.sensitiveLevelJsons[0]);
        //     if(angular.isDefined(item)){

        //     }
        // }
    }])
    .controller('sensitiveModifyCtrl', ['$scope', '$modalInstance', '$validation', '$timeout', 'initManageConSelectedService', 'item', function($scope, $modalInstance, $validation, $timeout, initManageConSelectedService, item) {
        initData();
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        $timeout(function() {
            $scope.confirm = function() {
                $validation.validate($scope.websiteSensitiveModifyForm).success(function() {
                    var sensitiveObj = {
                        'sensitiveWord': $scope.sensitiveWord,
                        'substituteWord': $scope.substituteWord,
                        'sensitiveLevel': $scope.sensitiveLevel
                    };
                    $modalInstance.close(sensitiveObj);
                });
            };
        });

        function initData() {
            // 初始化敏感级别
            $scope.sensitiveLevelJsons = initManageConSelectedService.websiteSensitiveLevel();
            $scope.sensitiveLevel = angular.copy($scope.sensitiveLevelJsons[item.SENSITIVELEVELDESC == '一般' ? 0 : 1]);
            $scope.sensitiveWord = item.SENSITIVEWORDS;
            $scope.substituteWord = item.SUBSTITUTEWORDS;
        }
    }])
    .controller('sensitiveImportCtrl', ['$scope', '$filter', '$modalInstance', 'Upload', 'modalDialog', 'trsHttpService', 'sensitiveAlert', function($scope, $filter, $modalInstance, Upload, modalDialog, trsHttpService, sensitiveAlert) {
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        $scope.confirm = function() {
            $scope.upload($scope.file);
        };
        $scope.chooseFile = function() {
            // console.log($scope.file);
        };
        $scope.upload = function(file) {
            var fileType = $filter('endsWith')(file.name, '.xls') || $filter('endsWith')(file.name, '.xlsx');
            if (fileType) {
                $scope.loadingPromise = Upload.upload({
                    url: '/wcm/openapi/uploadFile',
                    data: {
                        file: file
                    }
                }).then(function(resp) {
                    importFn(resp.data.imgName);
                }, function(resp) {});
            } else {
                modalDialog.alertType('文件格式错误', '请选择以.xls或.xlsx结尾的文件', 'error', 'confirm');
            }
        };

        /** [openDown description] 解决异常的下载模板方法 */
        $scope.openDown = function() {
            window.open('./manageConfig/sysManageMent/sensitiveWord/template/senstive_import.xls');
        };
        // 导入方法
        function importFn(result) {
            var params = {
                serviceid: 'mlf_websiteconfig',
                methodname: 'importSensitiveWords',
                ImportFile: result
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post', true).then(function(data) {
                modalDialog.alertType('导入敏感词成功', '', 'success', false, function() {
                    $modalInstance.close();
                });
            }, function(data) {
                if (data.code == '5000') {
                    modalDialog.alertType('导入的文件不是正确的excel文件格式，请重新导入', '', 'error', 'confirm');
                } else if (data.status === '-1') {
                    modalDialog.alertType(data.message, '', 'error', 'confirm');
                } else {
                    sensitiveAlert.multiReportsAlert(data, function() {
                        $modalInstance.close();
                    });
                }

            });
        }
    }]);
